import React, { useState, useEffect } from 'react'
import SocketContext from './context'
import { initSockets } from 'socket/htx'
import { htxWebSocket } from 'socket/htx/wsClient'
import { useSelector } from 'react-redux'
const SocketProvider = (props) => {
  const {markets} = useSelector((state) => state.crypto)
  const [state, setState] = useState({
    markets: [],
    klines: {
      symbol: '',
      data: [],
    },
    allKlines: {},
    orderBooks: [],
    trades: {},
    markupId: null,
  })
  useEffect(
    () =>{
     
      if(markets?.markets?.length && initSockets){
        console.log('updatin socket provider state')
          initSockets()
      htxWebSocket.setStateAndUpdateFunction({state, setState})
      }
      return ()=> htxWebSocket.disconnect()
    },
    [markets.markets?.length],
  )

  const value = {
    state,
    setState,
  }
  return (
    <SocketContext.Provider value={value}>
      {props.children}
    </SocketContext.Provider>
  )
}
export default SocketProvider
